import { ofType } from 'redux-observable';
import { catchError, from, map, mergeMap, of } from 'rxjs';

import { dispatchWithNextState } from '@spa/shared/utils/store';
import { replaceGuestWishlist } from '@spa/shared/clients/core';
import { PROFILE_ACTION_TYPES, setWishlistLoadingAction } from '@spa/shared/store/actions/profile';
import { addOfferToWishlist, removeOfferFromWishlist } from '@spa/shared/utils/wishlist';

export const addToWishlistEpic = (action$, state$, { store: { dispatch } }) =>
  action$.pipe(
    ofType(PROFILE_ACTION_TYPES.PROFILE_WISHLIST_ADD),
    mergeMap(({ payload: { offerId, city } }) => {
      dispatchWithNextState(setWishlistLoadingAction(true), dispatch);

      const { id: guestId } = state$.value.profile;
      const updatedWishlist = addOfferToWishlist(offerId, city, state$.value.profile);

      return from(replaceGuestWishlist(guestId, updatedWishlist)).pipe(
        map(() => ({ type: PROFILE_ACTION_TYPES.PROFILE_WISHLIST_SAVE, payload: { wishlist: updatedWishlist } })),
        catchError(_ => of({ type: PROFILE_ACTION_TYPES.PROFILE_WISHLIST_SAVE_ERROR }))
      );
    })
  );

export const removeFromWishlistEpic = (action$, state$, { store: { dispatch } }) =>
  action$.pipe(
    ofType(PROFILE_ACTION_TYPES.PROFILE_WISHLIST_REMOVE),
    mergeMap(({ payload: { offerId, city } }) => {
      dispatchWithNextState(setWishlistLoadingAction(true), dispatch);

      const { id: guestId } = state$.value.profile;
      const updatedWishlist = removeOfferFromWishlist(offerId, city, state$.value.profile);

      return from(replaceGuestWishlist(guestId, updatedWishlist)).pipe(
        map(() => ({ type: PROFILE_ACTION_TYPES.PROFILE_WISHLIST_SAVE, payload: { wishlist: updatedWishlist } })),
        catchError(_ => of({ type: PROFILE_ACTION_TYPES.PROFILE_WISHLIST_SAVE_ERROR }))
      );
    })
  );
